import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";

import { forgotPwd } from "../store/actions/authActions";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

class Recover extends Component {
  state = {
    menuToggled: false,
    email: "",
    password: "",
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };
  handleSubmit = (e) => {
    //console.log(this.state);
    this.authError = "";
    e.preventDefault();
    this.props.forgotPwd(this.state);
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    const { resetError, auth } = this.props;
    if (auth.uid) return <Redirect to="/" />;

    return (
      <div>
        <Helmet>
          <title>Password Recovery</title>
          <meta
            name="description"
            content="BoxFit is the ultimate home workout web-app
    with over 390 video exercises, 10 different workout categories and premium
    features such as Workout History & Weight Radar."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/recovery" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit is the ultimate home workout web-app
    with over 390 video exercises, 10 different workout categories and premium
    features such as Workout History & Weight Radar."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Recover your password:
              </h2>
              <form onSubmit={this.handleSubmit}>
                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Enter your email address"
                    id="email"
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  /* onClick={() => {
                  this.setState({ finished: false });
                }}*/
                  disabled={this.props.loading}
                >
                  <span role="img" aria-label="like">
                    👉
                  </span>{" "}
                  Send me a reset link
                </button>
                <div style={{ height: "20px" }}></div>
                {resetError && !this.props.loading ? (
                  <div
                    style={{
                      color: "#EE1D52",
                      fontSize: "18px",
                    }}
                  >
                    {resetError}
                  </div>
                ) : null}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    resetError: state.auth.resetError,
    auth: state.firebase.auth,
    loading: state.auth.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPwd: (creds) => dispatch(forgotPwd(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Recover);
